import React from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ServiceCTA from '../components/ServiceCTA'

const ConsultancyOverviewPage = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const domains = [
        {
            title: t('consultancyOverview.domains.nutritionCosmetics.title'),
            desc: t('consultancyOverview.domains.nutritionCosmetics.desc'),
            path: '/service/consultancy/nutrition-cosmetics',
            icon: 'spa'
        },
        {
            title: t('consultancyOverview.domains.agricultureFood.title'),
            desc: t('consultancyOverview.domains.agricultureFood.desc'),
            path: '/service/consultancy/agriculture-food',
            icon: 'agriculture'
        }
    ]

    return (
        <ServiceLayout
            breadcrumbs={[
                { label: t('header.home'), path: '/' },
                { label: t('header.service'), path: '/service' },
                { label: t('header.services.consultancy.title') }
            ]}
            title={t('consultancyOverview.title')}
            subtitle={t('consultancyOverview.subtitle')}
        >
            <p className="text-text-muted text-base leading-relaxed mb-8">
                {t('consultancyOverview.intro')}
            </p>

            <div className="space-y-4">
                {domains.map((domain, i) => (
                    <button
                        key={i}
                        onClick={() => navigate(domain.path)}
                        className="group flex items-center gap-5 p-6 bio-card-static rounded-xl border border-border-light hover:border-primary/30 hover:bg-primary-50 transition-all text-left w-full"
                    >
                        <div className="w-14 h-14 rounded-lg bg-primary-50 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors flex-shrink-0">
                            <span className="material-symbols-outlined text-2xl">{domain.icon}</span>
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-lg mb-1">{domain.title}</h3>
                            <p className="text-text-muted text-sm">{domain.desc}</p>
                        </div>
                        <ArrowRight className="w-5 h-5 text-text-muted group-hover:text-primary transition-colors flex-shrink-0" />
                    </button>
                ))}
            </div>
            <ServiceCTA />
        </ServiceLayout>
    )
}

export default ConsultancyOverviewPage
